import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';

export enum ALERT_MESSAGE {
	INFO = 'info',
	DANGER = 'danger',
	WARNING = 'warning'
}

export interface Alert {
	type: ALERT_MESSAGE;
	message: string;
}

@Injectable({
	providedIn: 'root'
})
export class AlertService {
	private message$: Subject<Alert> = new Subject();
	public clearAll$: Subject<boolean> = new Subject();
	constructor(
		private readonly translate: TranslateService,
	) {
	}

	public getMessages(): Subject<Alert> {
		return this.message$;
	}
	public addRawMessage(
		type: ALERT_MESSAGE,
		message: string,
	): void {
		this.message$.next({
			type: type,
			message: message
		});
	}

	public addMessage(
		type: ALERT_MESSAGE,
		messageKey: string,
		clearAll: boolean = false
	): void {
		if (clearAll) {
			this.clearAll$.next(true);
		}
		this.translate.get(messageKey).subscribe((message: string) => {
			this.addRawMessage(type, message);
		});

	}
}
